// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1___fbebe641d5365b5e90f","cls2":"ToolsMenu-cls2__a5b8862487083335c5f3 ToolsMenu-cls1___fbebe641d5365b5e90f"};